<div class="wrapper-page faq-page">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <span class="header-text">Obaveštenja</span>
      <button class="zc-btn zc-btn--primary" (click)="isCreateNotificationModalOpen = true"><span>Kreiraj notifikaciju</span></button>
    </div>
    <div class="zc-wrapper-tabs">
      <div class="zc-tab" (click)="activeTab = NotificationTabsEnums.users" [ngClass]="{'active': activeTab === NotificationTabsEnums.users}">
        <div class="wrapper-tab-notification">
          <span>Korisnici</span>
          <span class="more-notification" *ngIf="usersNotificationsCount">{{usersNotificationsCount}}</span>
        </div>
      </div>
      <div class="zc-tab" (click)="activeTab = NotificationTabsEnums.payment" [ngClass]="{'active': activeTab === NotificationTabsEnums.payment}">
        <div class="wrapper-tab-notification">
          <span>Plaćanje</span>
          <span class="more-notification" *ngIf="paymentNotificationsCount">{{paymentNotificationsCount}}</span>
        </div>
      </div>
      <div class="zc-tab" (click)="activeTab = NotificationTabsEnums.support" [ngClass]="{'active': activeTab === NotificationTabsEnums.support}">
        <div class="wrapper-tab-notification">
          <span>Podrška</span>
          <span class="more-notification"  *ngIf="supportNotificationsCount">{{supportNotificationsCount}}</span>
        </div>
      </div>
      <div class="zc-tab" (click)="activeTab = NotificationTabsEnums.custom" [ngClass]="{'active': activeTab === NotificationTabsEnums.custom}">
        <span>Kreirane notifikacije</span>
      </div>
    </div>
    <gr-notification-users-tab
      [hidden]="activeTab !== NotificationTabsEnums.users"
      (usersNotificationsCount)="usersNotificationsCount = $event">
    </gr-notification-users-tab>
    <gr-notification-payment-tab
      [hidden]="activeTab !== NotificationTabsEnums.payment"
      [notificationsCount]="paymentNotificationsCount"
      (paymentNotificationsCount)="paymentNotificationsCount = $event">
    </gr-notification-payment-tab>
    <gr-notification-support-tab
      [hidden]="activeTab !== NotificationTabsEnums.support"
      (supportNotificationsCount)="supportNotificationsCount = $event">
    </gr-notification-support-tab>
    <gr-notification-custom-tab
      [hidden]="activeTab !== NotificationTabsEnums.custom"
      (editNotification)="customNotificationForEdit = $event"
      [updateNotification]="updateNotification">
    </gr-notification-custom-tab>
  </div>
</div>

<gr-create-notification-modal
  *ngIf="isCreateNotificationModalOpen || customNotificationForEdit"
  [notificationForEdit]="customNotificationForEdit"
  (closeModal)="isCreateNotificationModalOpen = false; customNotificationForEdit = null"
  (confirmCreateNotification)="updateNotification = true; isCreateNotificationModalOpen = false; customNotificationForEdit = null"
  (confirmEditNotification)="updateNotification = true; isCreateNotificationModalOpen = false; customNotificationForEdit = null"
></gr-create-notification-modal>
